<template>
  <el-dialog
    class="dialog"
    title="新增预约范围"
    :visible.sync="addDialog.flag"
    width="70%"
    destroy-on-close
    :close-on-click-modal="false"
    @close="cancel"
  >
  <div class="top_container">
    <el-form class="ruleForm" :inline="true" :model="ruleform" size="small" >
      <el-form-item label="管理主体：">
        <el-select
          clearable
          multiple
          collapse-tags
          v-model="ruleform.leaderTypeMore"
          placeholder="全部"
        >
          <el-option
            v-for="(item, i) in leaderTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="干部级别：">
        <el-select
          clearable
          multiple
          collapse-tags
          v-model="ruleform.cadreLevels"
          placeholder="全部"
        >
          <el-option
            v-for="(item, i) in cadreLevelData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户状态：">
        <el-select
          v-model="ruleform.userStatus"
          placeholder="用户状态"
        >
          <el-option
            v-for="(item, i) in userStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="考核状态：">
        <el-select
          v-model="ruleform.isExam"
          placeholder="考核状态"
        >
          <el-option
            v-for="(item, i) in publicData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="浙政钉绑定状态：">
        <el-select
          v-model="ruleform.bindStatus"
          placeholder="考核状态"
        >
          <el-option
            v-for="(item, i) in bindStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="近五年集中培训学时数：" class="m-l-14">
        <range-input ref="totalRange" @change="totalChange"/>
      </el-form-item>
      <!-- <el-form-item label="网络自学学时数：" class="m-l-14">
        <range-input @change="onlineChange"/>
      </el-form-item> -->
    </el-form>
    <div class="main_title">选择授权部门</div>
  </div>
  <div class="main_container">
    <div class="left_content content_style">
      <el-input
        class="search-dept"
        prefix-icon="el-icon-search"
        v-model.trim="deptName"
        @input="searchDep"
        placeholder="请输入部门名称"
        clearable
      />
      <!-- 默认模式 -->
      <div class="main_content" v-if="!deptName">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item v-for="(item,i) in breadcrumbList" :key="'bread'+i">
            <span @click="checkBread(item)">{{item.name}}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="check_wrap" v-for="(item, i) in breadcrumbList" :key="'check_wrap'+i">
          <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="v => handleCheckAllChange(v, i)" v-if="i == curBreadIdx">全选</el-checkbox>
          <el-checkbox-group v-model="defaultCheckedKeys" v-if="i == curBreadIdx">
            <div class="check_list" v-if="!loading">
              <el-checkbox v-for="dept in breadcrumbList[i].deptList" :label="dept.uuid" :key="dept.uuid" @change="v => nodeChange(v, dept)">
                <span v-if="dept.hasChildren && !(defaultCheckedKeys.indexOf(dept.uuid) > -1)" @click="getNode(dept, i)">{{dept.deptName}}</span>
                <span v-else>{{dept.deptName}}</span>
                <i class="el-icon-arrow-right" v-if="dept.hasChildren && !(defaultCheckedKeys.indexOf(dept.uuid) > -1)" @click="getNode(dept, i)"></i>
                <i class="el-icon-arrow-right arrow_disable" v-if="dept.hasChildren && (defaultCheckedKeys.indexOf(dept.uuid) > -1)"></i>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <!-- 搜索模式 -->
      <div class="main_content" v-if="!!deptName">
        <div class="check_wrap">
          <el-checkbox-group v-model="defaultCheckedKeys">
            <div class="check_list" v-if="!loading">
              <el-checkbox v-for="dept in searchList" :label="dept.uuid" :key="dept.uuid" @change="v => nodeChange(v, dept)">
                <el-tooltip class="item" style="height: 24x; margin-bottom: -3.5px;" effect="dark"
                    :content="dept.fullName" placement="top-start">
                    <div class="ellipsis--l1">{{ dept.simpleName }}</div>
                  </el-tooltip>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="line_to_result"><i class="el-icon-arrow-right"></i></div>
    <div class="right_content content_style">
      <div class="results-title">
        <span class="closeall" @click="clearAll">清空</span><span>已选组织({{checkedEnrollDeptVos.length}})</span>
      </div>
      <div class="item-list-row">
        <div class="item-list-row-item" v-for="(item, i) in checkedEnrollDeptVos" :key="'EnrollDept' + i">
          <span class="row-item-text">
            <span class="item-list-row-medium">{{item.deptName}}</span>
          </span>
          <i class="el-icon-close del-icon" @click="removeNode(item, i, true)"></i>
        </div>
      </div>
    </div>
  </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="selectDept" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { deptTreeForClass } from "@/api/dept";
import { getSysParamByTypes } from "@/api/sysParam";
import { getTopDepts } from "@/api/dept";
import { addPopupDepts } from "@/api/resourceService";
import RangeInput from "@/components/RangeInput";
import "@/views/onlineClass/add/dept.scss";
export default {
  // props: ["enrollDeptVos"],
  components:{
    RangeInput,
  },
  props: {
    addDialog: {
      type: Object,
      default: () => {
        return {
          flag: false
        };
      },
    },
    uuid: {
      type: String,
      default: () => ""
    },
    // 用于线上，线下区分
    bizType: {
      type: Number,
      default: 1,
    },
    ticketId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      deptName: '',
      breadcrumbList: [{name: "报名部门", index: 0, parentId: "0", deptList: [], checkAll: false, isIndeterminate: true}],
      curBreadIdx: 0,
      loading: false,
      searchList: [],
      checkedEnrollDeptVos: [],
      userStatusData: [],
      leaderTypeData: [],
      publicData: [],
      cadreLevelData: [],
      bindStatusData: [],
      ruleform: {
        leaderType: [],
        isExam: "",
        userStatus: "",
        bindStatus: "",
        cadreLevels: [],
      }
    };
  },
  computed: {
    defaultCheckedKeys: {
      get() {
        return this.checkedEnrollDeptVos.map((ele) => ele.deptId);
      },
      set(v) {}
    }
  },
  created() {
    this.getNode({}, null);
    this.getSysParamByTypes(["USER_LEADER_TYPE", "USER_STATUS", "IS_VALID", "CADRE_LEVEL", "USER_BIND_STATUS"]);
    // this.checkedEnrollDeptVos = JSON.parse(JSON.stringify(this.enrollDeptVos));
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // res.data["USER_LEADER_TYPE"].splice(0, 0, {
        //   paramKey: "",
        //   paramValue: "全部",
        // });
        res.data["USER_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["IS_VALID"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["USER_BIND_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.leaderTypeData = res.data["USER_LEADER_TYPE"];
        this.userStatusData = res.data["USER_STATUS"];
        this.publicData = res.data["IS_VALID"];
        this.cadreLevelData = res.data["CADRE_LEVEL"];
        this.bindStatusData = res.data["USER_BIND_STATUS"];
      });
    },
    cancel() {
      this.curBreadIdx = 0;
      this.breadcrumbList.splice(1);
      this.$emit("closeDialog", false);
    },
    // 全选
    handleCheckAllChange(val, index) {
      // 当前页数据
      this.breadcrumbList[index].isIndeterminate = false;
      let curCheckList = this.breadcrumbList[index].deptList || [];
      if (curCheckList.length > 0) {
        for (let i=0; i<curCheckList.length; i++) {
          this.nodeChange(val, curCheckList[i], 1);
        }
      }
    },
    // 单选
    nodeChange(val, node, type) {
      let checkedEnrollDeptVos = this.checkedEnrollDeptVos.map(ele => ele.deptId);
      let idx = checkedEnrollDeptVos.indexOf(node.uuid);
      if (val) {
        // 当前选中已存在、返回；反之新增
        if (idx > -1) return;
        this.checkedEnrollDeptVos.unshift({
          deptId: node.uuid,
          deptName: node.deptName,
          parentId: node.parentId,
          deptLevelCode: node.deptLevelCode
        });
      } else {
        // 当前选中已存在、删除；反之、返回
        if (idx > -1) {
          this.removeNode(node, idx);
        } else return;
      }
      if (type !== 1) {
        this.listenCheckAll(this.breadcrumbList[this.curBreadIdx].deptList);
      }
    },
    // 右边移除
    removeNode(item, i, checkAll) {
      this.checkedEnrollDeptVos.splice(i, 1);
      // 是否检查全选状态
      let deptList = this.breadcrumbList[this.curBreadIdx].deptList
      let deptIdArr = deptList.map(ele => ele.uuid);
      if (checkAll && deptIdArr.indexOf(item.deptId) > -1) {
        this.listenCheckAll(deptList);
      }
    },
    // 右边清空
    clearAll() {
      this.checkedEnrollDeptVos = [];
      // 清除全选
      for (let i=0; i<this.breadcrumbList.length; i++) {
        this.breadcrumbList[i].isIndeterminate = false;
      }
    },
    // 切换面包屑
    checkBread(item) {
      this.curBreadIdx = item.index;
      this.breadcrumbList.splice(this.curBreadIdx + 1);
    },
    // 全选监听
    listenCheckAll(nodeList) {
      let checkedNum = 0;
      for (let i=0; i<nodeList.length; i++) {
        if (this.defaultCheckedKeys.indexOf(nodeList[i].uuid) > -1) {
          checkedNum ++
        }
      }
      this.breadcrumbList[this.curBreadIdx].checkAll = checkedNum === nodeList.length;
      this.breadcrumbList[this.curBreadIdx].isIndeterminate = checkedNum > 0 && checkedNum < nodeList.length;
    },
    // 加载下级节点
    getNode(item, level) {
      this.loading = true;
      let params = {
        deptName: this.deptName,
        bNotAcrossDept: 1
      };
      if (item.uuid) {
        params = { parentId: item.uuid };
      }
      if (level !== null) {
        this.curBreadIdx ++;
        this.breadcrumbList[this.curBreadIdx] = {
          name: item.deptName,
          parentId: item.uuid,
          index: this.curBreadIdx,
          deptList: [],
          checkAll: false, 
          isIndeterminate: true
        };
      }
      deptTreeForClass(params).then((res) => {
        if (!res || res.code != 0) return;
        if (res.data.length > 0) {
          this.breadcrumbList[this.curBreadIdx].deptList = res.data;
          this.listenCheckAll(res.data);
        }
        this.loading = false;
      });
    },
    // 搜索
    searchDep(val) {
      this.searchList = [];
      this.loading = true;
      let params = {
        deptName: this.deptName,
        bNotAcrossDept: 1
      };
      deptTreeForClass(params).then((res) => {
        if (!res || res.code != 0) return;
        if (res.data.length > 0) {
          this.searchList = res.data;
        }
        this.loading = false;
      });
    },
    // 确定-选择部门
    selectDept() {
      if (this.checkedEnrollDeptVos.length > 0) {
        // 查询部门树顶节点-zhaogang
        getTopDepts(this.checkedEnrollDeptVos).then((res) => {
          if (!res || res.code != 0) return;
          this.topDeptList = res.data || [];
          this.saveDepts();
        });
      } else {
        this.$message.warning("请先选择至少一个部门！");
      }
    },
    // 保存结果
    saveDepts() {
      let deptLevelCodes = this.topDeptList.map(ele => ele.deptLevelCode);
      let params = {
        ...this.ruleform,
        deptLevelCodes,
        bizType: this.bizType,
        ticketId: this.ticketId,
        ticketDetailId: this.uuid,
      };
      addPopupDepts(params).then((res) => {
        if (!res || res.code != 0) return;
        this.curBreadIdx = 0;
        this.breadcrumbList.splice(1);
        this.$message.success(res.msg);
        this.$emit("closeDialog", true);
      });
    },
    totalChange(value) {
      if (value && value.length > 1) {
        this.ruleform.minTotalLength = value[0];
        this.ruleform.maxTotalLength = value[1];
      }
      
    },
    onlineChange(value) {
      if (value && value.length > 1) {
        this.ruleform.minOnlineLength = value[0];
        this.ruleform.maxOnlineLength = value[1];
      }
    },
  },
};
</script>
<style lang="scss" scoped>

</style>